"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/faqSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "Yes, simply visit our website and log in or create an account. Search for a doctor based on specialization, location, or availability & confirm your booking." | "Yes, you can usually request a specific doctor when booking your appointment, though availability may vary based on their schedule." | "If you need to cancel or reschedule your appointment, contact the doctor as soon as possible to inform them and to reschedule for another available time slot." | "If you know you will be late, it's courteous to call the doctor's office and inform them. Depending on their policy and schedule, they may be able to accommodate you or reschedule your appointment." | "Yes, in many cases, you can book appointments for family members or dependents. However, you may need to provide their personal information and consent to do so." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" | "headingFive" */
    h30Id: string;
    /** Detected variants: "How do I book an appointment with a doctor?" | "Can I request a specific doctor when booking my appointment?" | "What should I do if I need to cancel or reschedule my appointment?" | "What if I'm running late for my appointment?" | "Can I book appointments for family members or dependents?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" | "#collapseFive" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeEightFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "faq-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/company/faq-img-3.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "faq-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/company/faq-img-4.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Experts Respond" */
    sectionDiv0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "Commonly" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Asked Questions" */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div1DivDataWowDuration?: string;
    /** Default: "faq-details-one" */
    sectionDiv0Div0Div1Div1Div0DivId?: string;
    faqSectionAccordions: FaqSectionAccordionsItem[];
    faqSectionAccordionsItemWrapper?: (item: FaqSectionAccordionsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkVisible?: boolean;
    faqSectionAccordionsLinkRenderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Visible?: boolean;
    faqSectionAccordionsH3Renderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeEightFaqSectionGenerated: FC<HomeEightFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "faq-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/company/faq-img-3.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "faq-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/company/faq-img-4.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0Div0DivText = "Our Experts Respond",
    sectionDiv0Div0Div1Div0H20H2Text = "Commonly",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "Asked Questions",
    sectionDiv0Div0Div1Div1Div0DivId = "faq-details-one",
    sectionDiv0Div0Div1Div1DivDataWowDuration = "1s",
    divH30H3Props,
    divH30Link0LinkProps,
    sectionDiv0Div0ClassName,
    faqSectionAccordions,
    faqSectionAccordionsItemWrapper,
    faqSectionAccordionsRenderer,
    faqSectionAccordionsLinkVisible,
    faqSectionAccordionsLinkRenderer,
    faqSectionAccordionsH3Visible,
    faqSectionAccordionsH3Renderer,
    faqSectionAccordionsLinkProps,
    faqSectionAccordionsH3Props,
}) => {
    return (
        <section className="faq-section-eight section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-5">
                        <div className="faq-support">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="section-header section-header-eight">
                            <div className="section-sub-title">
                                <span className="dot" />
                                {sectionDiv0Div0Div1Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    <span className="line">{sectionDiv0Div0Div1Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                        </div>
                        <div className="faq-info wow zoomIn" data-wow-duration={sectionDiv0Div0Div1Div1DivDataWowDuration}>
                            <div className="accordion" id={sectionDiv0Div0Div1Div1Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordions,
                                    (item: FaqSectionAccordionsItem) => (
                                        <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                            {renderItemNode(faqSectionAccordionsH3Visible, faqSectionAccordionsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionsH3Props === "function" ? faqSectionAccordionsH3Props(item) : (faqSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    {renderItemNode(faqSectionAccordionsLinkVisible, faqSectionAccordionsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof faqSectionAccordionsLinkProps === "function" ? faqSectionAccordionsLinkProps(item) : (faqSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName ?? "accordion-body"}>
                                                    <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionsItemWrapper,
                                    faqSectionAccordionsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeEightFaqSectionGenerated;
